import dynamic from 'next/dynamic';
import React from 'react';

import type { NextPageWithLayout } from 'nextjs/types';

import PageNextJs from 'nextjs/PageNextJs';

import LayoutGetTestTokens from 'ui/shared/layout/LayoutGetTestTokens';

const GetTestTokens = dynamic(() => import('ui/pages/GetTestTokens'), { ssr: false });

const Page: NextPageWithLayout = () => {
  return (
    <PageNextJs pathname="/get-test-tokens">
      <GetTestTokens/>
    </PageNextJs>
  );
};

Page.getLayout = function getLayout(page: React.ReactElement) {
  return (
    <LayoutGetTestTokens>
      { page }
    </LayoutGetTestTokens>
  );
};

export default Page;

export { base as getServerSideProps } from 'nextjs/getServerSideProps';
